/**
 * Developed By Aritra Basak, EY
 */
import React, { useEffect } from "react";
import "./assets/styles/App.css";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { routes } from "./constants/routes";
import { URI_PREFIX, URI } from "./constants/index";
import { asyncGet, asyncPost } from "./common/utils";
import CircularProgress from "@material-ui/core/CircularProgress";

const drawerWidth = 240;
export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "white",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#2296F3",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));
global.isLoggedIn = false;
function App() {
  const classes = useStyles();
  const [isLoggedIn, setLogin] = React.useState(false);
  const [loginAs, setLoginType] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(true);

  /**
   * Get the user IP throught the webkitRTCPeerConnection
   * @param onNewIP {Function} listener function to expose the IP locally
   * @return undefined
   */
  function getUserIP(onNewIP) {
    //  onNewIp - your listener function for new IPs
    //compatibility for firefox and chrome
    var myPeerConnection =
      window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection;
    var pc = new myPeerConnection({
        iceServers: [],
      }),
      noop = function () {},
      localIPs = {},
      ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
      key;

    function iterateIP(ip) {
      if (!localIPs[ip]) onNewIP(ip);
      localIPs[ip] = true;
    }

    //create a bogus data channel
    pc.createDataChannel("");

    // create offer and set local description
    pc.createOffer(function (sdp) {
      sdp.sdp.split("\n").forEach(function (line) {
        if (line.indexOf("candidate") < 0) return;
        line.match(ipRegex).forEach(iterateIP);
      });

      pc.setLocalDescription(sdp, noop, noop);
    }, noop);

    //listen for candidate events
    pc.onicecandidate = function (ice) {
      if (
        !ice ||
        !ice.candidate ||
        !ice.candidate.candidate ||
        !ice.candidate.candidate.match(ipRegex)
      )
        return;
      ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
    };
  }

  // Usage

  getUserIP(function (ip) {
    // alert(
    //   "Got your IP ! : " + ip + " | verify in http://www.whatismypublicip.com/"
    // );
  });

  useEffect(() => {
    setShowLoader(true);
    let url = new URL(window.location);
    let params = new URLSearchParams(url.search);
    let token = params.get("token");
    let institute = params.get("institute");
    let loginAs = params.get("type");
    let user = params.get("user");
    global.healthIdParam =
      params.get("healthId") === null ? "" : params.get("healthId");
    global.loginAs = loginAs;
    global.instituteId = institute;
    global.user = user;
    global.mobileNumber =
      params.get("mobile") === null ? "" : params.get("mobile");
    global.benificiaryName =
      params.get("benificiaryName") === null
        ? ""
        : params.get("benificiaryName");
    global.aadharNumber =
      params.get("aadhaar") === null ? "" : params.get("aadhaar");
    openWindow(institute, token);
  }, []);
  //On load of the app the token and the institute gets verified so to proceed with the app. and another token is generated to verify internal features of the app. like generating & validating OTP
  const openWindow = async (institute, token) => {
    const __oo = {
      instituteId: institute,
      token: token,
    };
    const res = await asyncPost(
      URI.validateReactOpenToken,
      __oo,
      true,
      false,
      ""
    );
    if (res && res.status == 2000) {
      //debugger;
      global.clientId = res.data.clientData.client_id;
      global.primaryColour =
        res.data.clientData.primaryColour !== null
          ? res.data.clientData.primaryColour
          : "linear-gradient(90deg, rgba(107,198,245,1) 14%, rgba(72,125,185,1) 31%, rgba(26,63,147,1) 100%)";
      global.secondaryColour =
        res.data.clientData.secondaryColour !== null
          ? res.data.clientData.secondaryColour
          : "#3f51b5";
      global.m2BasePathUrl = res.data.clientData.integratorBasePathUrl;
      global.m2GetCareContextUrl = res.data.clientData.m2GetCareContextUrl;
      global.m2UpdateCareContextUrl =
        res.data.clientData.m2UpdateCareContextStatusUrl;
      global.m3Hl7Url = res.data.clientData.m3GetHl7DataUrl;
      global.isGovtEntity = res.data.clientData.isGovtEntity;
      global.updateCareContextOldMethod =
        res.data.clientData.isClientDetailsUpdateOldMethod;
      const __oo = {
        id: res.data.clientData.client_id,
        instituteId: institute,
      };
      const resWebToken = await asyncPost(
        URI.generateWebAccessToken,
        __oo,
        true,
        false,
        ""
      );
      if (resWebToken && resWebToken.status == 2000) {
        //debugger;
        global.token = resWebToken.data.token;
        setShowLoader(false);
        setLogin(true);
      } else {
        setShowLoader(false);
      }
    } else {
      setShowLoader(false);
    }
  };
  const onLogin = (isLoggedIn, loginAs) => {
    setLogin(isLoggedIn);
    setLoginType(loginAs);
  };
  const onSignIn = (isLoggedIn, loginAs) => {
    setLogin(isLoggedIn);
    setLoginType(loginAs);
  };
  return (
    <div>
      {isLoggedIn ? (
        <div className={classes.root}>
          <CssBaseline />
          <Router>
            <main className={classes.content}>
              <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <div style={{ display: "flex" }}>
                      <div style={{ flex: 1, padding: "0px" }}>
                        <Switch>
                          {routes.map((route, index) => (
                            <Route
                              key={index}
                              path={route.path}
                              exact={route.exact}
                              children={<route.main />}
                            />
                          ))}
                        </Switch>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Container>
            </main>
          </Router>
        </div>
      ) : (
        <div>
          {!showLoader ? (
            <div style={{ textAlign: "center", marginTop: 200 }}>
              <h5>Invalid Session Request. Please Try Again.</h5>
            </div>
          ) : (
            <div style={{ textAlign: "center", marginTop: 100 }}>
              <h4>
                <span style={{ color: global.secondaryColour }}>
                  Welcome to ABDM Connector.
                </span>
              </h4>
              <CircularProgress style={{ color: global.secondaryColour }} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
export default App;
